'use client';

import { FC, PropsWithChildren } from 'react';
import { SurfsideProvider } from '@surfside/ads-react';

type SurfsideAdsProviderProps = PropsWithChildren<{
  locationId?: string;
}>;

export const SurfsideAdsProvider: FC<SurfsideAdsProviderProps> = ({
  children,
  locationId,
}) => {
  const accountId = process.env.NEXT_PUBLIC_SURFSIDE_ACCOUNT_ID ?? '';
  const channelId = process.env.NEXT_PUBLIC_SURFSIDE_CHANNEL_ID ?? '';
  const siteId = process.env.NEXT_PUBLIC_SURFSIDE_SOURCE_ID ?? '';

  return (
    <SurfsideProvider
      accountId={accountId}
      channelId={channelId}
      locationId={locationId}
      siteId={siteId}
    >
      {children}
    </SurfsideProvider>
  );
};
